// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer___e0bO","inner":"footer_inner__rr9c4","logo":"footer_logo__H37xW"};